import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ELogoutActionTypes, TLogoutFailed } from './types';

export const logoutFailure: () => TLogoutFailed = actionGenerator<ELogoutActionTypes.Failed>(ELogoutActionTypes.Failed);
